import SecureLinkFile from './SecureLinkFile.component';

export default SecureLinkFile;